import * as css from './Btn.css';
import ConditionalWrapper from '../../conditionalWrapper/ConditionalWrapper';
import {XHR_LOADING_STATE} from '../../../assets/constants/constants';
function Btn({style='',className='',children, onClick,disabled=false,href=null, target=null, dataCy=undefined}) {

    return (
        <ConditionalWrapper condition={!!href} wrapper={(children)=><a href={href} target={target}>{children}</a>} data-cy={'btnHref'}>
            <css.btn
                $btnCss={style}
                id="classicButton"
                data-cy={dataCy ? `${dataCy}-button` : 'classic-button'}
                disabled={className === XHR_LOADING_STATE}
                className={`${className} ${disabled && ' disabled'}`}
                {...((disabled || href || className === XHR_LOADING_STATE) ? {} : {onClick})}>
                {className !== XHR_LOADING_STATE && children}
            </css.btn>
        </ConditionalWrapper>

    );
}

export default Btn;
